import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { formatDate } from "@angular/common";
import { NotificationService } from "src/app/services/notification.service";
import { finalize, Subject } from "rxjs";
import { OperatoriService } from "../operatori.service";
import Swal from "sweetalert2";
import { PermissionsService } from "src/app/services/permissions.service";
import { DialogService } from "src/app/services/dialog.service";
import { AddAlocareDirectieComponent } from "./add-alocare-directie/add-alocare-directie.component";
import { DataTablesResponse } from "src/app/interfaces/data-table-response.interface";


@Component({
    selector: 'app-alocare-directie',
    templateUrl: './alocare-directie.component.html',
    styleUrls: ['./alocare-directie.component.scss']
})
export class AlocareDirectieComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    isLoading = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink = this.operatoriService.operatorAccessListDtUrl;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { id_user: number },
        private dialogRef: MatDialogRef<AlocareDirectieComponent>,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private operatoriService: OperatoriService,
        private notificationService: NotificationService,
        private http: HttpClient,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 10,
            order: [[0, "asc"]],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                // Important, add id_user to dtParams
                dataTablesParameters.id_user = this.data.id_user;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    orderable: true,
                    data: 'id',
                },
                {
                    title: 'Nume',
                    orderable: false,
                    data: 'name_user',
                },
                {
                    title: 'Direcție',
                    orderable: false,
                    data: 'denumire_directie',
                    render: (data: any, type: string, row: any) => {
                        return `<span>${row.denumire_directie ? row.denumire_directie : 'n/a'}</span>`
                    }
                },
                {
                    title: 'Compartiment',
                    orderable: false,
                    data: 'denumire_compartiment',
                    render: (data: any, type: string, row: any) => {
                        return `<span>${row.denumire_compartiment ? row.denumire_compartiment : 'n/a'}</span>`
                    }
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (data: any, type: any, row: any, met: any) => {
                        return (
                            `
                            <div class="d-flex align-center justify-content-left">
                                <button class="action-btn delete me-1" title="Sterge">
                                    <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/
                                </button>
                            </div>
                            `
                        );
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;

                if (deleteIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'dgaspc-module.settings.prioritati-cerere.delete'
                    //     )
                    // ) {
                    //     deleteIcon.style.display = 'none';
                    // }

                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteEntry(id);
                    });
                }
            }
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    deleteEntry(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să ștergeți această înregistrare!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.operatoriService.deleteOperatorAccess(id).subscribe(
                    () => {
                        this.rerenderDT();
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.deleted,
                            text: 'Înregistrare ștearsă cu succes.',
                            icon: 'success',
                            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                        });
                    },
                    (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    });
            }
        });
    }

    addDirectieCompartiment() {
        const dialogRef = this.dialog.open(AddAlocareDirectieComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                id_user: this.data.id_user
            }
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare adaugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }
}
